import React, { useState } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import FieldsOfStudyTable from '../Components/FieldsOfStudyTable';
import DeleteModal from "../../../../Util/DeleteModal";
import { useBoolean } from '@fluentui/react-hooks';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [selectedFieldsOfStudy, setSelectedFieldsOfStudy] = useState(undefined);
    const [selectedFieldsOfStudyTitle, setSelectedFieldsOfStudyTitle] = useState("");
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: fieldsOfStudy, loading }, refetch] = useAxios("scholarships/fields-of-study");

    if (loading) return <Spinner className="absolute-center" label="Loading Fields of Study..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Scholarship Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <FieldsOfStudyTable
                fieldsOfStudy={fieldsOfStudy && fieldsOfStudy.length > 0 ? [...fieldsOfStudy].sort((a, b) => a.name.localeCompare(b.name)) : []}
                setSelectedFieldsOfStudy={setSelectedFieldsOfStudy}
                setSelectedFieldsOfStudyTitle={setSelectedFieldsOfStudyTitle}
                selectedFieldsOfStudy={selectedFieldsOfStudy}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={(id, title) => {
                    setSelectedFieldsOfStudy(id);
                    setSelectedFieldsOfStudyTitle(title || "");
                    toggleDeleteModal();
                }}
                refetch={refetch}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`scholarships/fields-of-study/delete/${selectedFieldsOfStudy}/`}
                resourceName={selectedFieldsOfStudyTitle}
                resourceType="category"
                confirmationValue={selectedFieldsOfStudyTitle || undefined}
            />
        </>
    );
};

export default DefaultPage;
